import PathStep from "./PathStep"
import "./PathStepContainer.css"
import PathStepEditor from "./PathStepEditor"

const PathStepContainer = ({ isEditing, item, index, standalone }) => (
  <div className="PathStepContainer" style={{ zIndex: 100 - item.order }}>
    {isEditing ? (
      <PathStepEditor item={item} index={index} standalone={standalone} />
    ) : (
      <PathStep item={item} standalone={standalone} />
    )}
  </div>
)

PathStepContainer.displayName = "PathStepContainer"

export default PathStepContainer
